import React, { useMemo } from 'react';
import { Navigation } from '@shopify/polaris';
import { AlertBubbleIcon } from '@shopify/polaris-icons';
import { useLocation } from 'react-router-dom';
import { useCollectionsPermissions } from '../../shared/useCollectionsPermissions';

const CollectionsSidebar: React.FC = () => {
  const location = useLocation();
  const { isCollectionsAdmin } = useCollectionsPermissions();

  const subNavigationItems = useMemo(() => {
    const items = [
      { label: 'Clients', url: '/collections/clients', disabled: false },
      { label: 'Email History', url: '/collections/email-history', disabled: false },
    ];

    if (isCollectionsAdmin) {
      items.splice(1, 0, { label: 'Departments', url: '/collections/departments', disabled: false });
      items.push(
        { label: 'Configuration', url: '/collections/configuration', disabled: false },
        { label: 'Scheduled Emails', url: '/collections/scheduled-emails', disabled: false },
        { label: 'Servman SQL Logs', url: '/collections/servman_sql_logs', disabled: false },
      );
    }

    return items;
  }, [isCollectionsAdmin]);

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            label: isCollectionsAdmin ? 'Admin Collections' : 'Collections',
            url: '/collections/clients',
            icon: AlertBubbleIcon as any,
            matches: true,
            subNavigationItems,
          },
        ]}
      />
    </Navigation>
  );
};

export default CollectionsSidebar;
